export const enum EmailStatus {
    "registered",
    "not-found",
}
